/**
 * Sidebar
 */

export default function sidebar() {

  const sidebar = document.querySelectorAll('[data-js="sidebar-trigger"]');
  
  // When Navbar exists
  if (sidebar.length > 0) {
    var headerFromTOP = window.pageYOffset + document.querySelector('.sidebarMobile').getBoundingClientRect().top

    // Show an overlay on the navbar toggler click
    var trigger = function () {
      [].forEach.call(sidebar, function(trigger) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          document.body.classList.toggle('sidebar--opened');
        }, false);
      });
    };
    trigger();

    

    window.onresize = function() {
      headerFromTOP = window.pageYOffset + document.querySelector('.sidebarMobile').getBoundingClientRect().top
    };

    window.onscroll = function() {
      fixedMobileHeader(headerFromTOP)
    };
    function fixedMobileHeader(headerFromTOP) {
      if (document.body.scrollTop > headerFromTOP || document.documentElement.scrollTop > headerFromTOP) {
        document.querySelector('.sidebarMobile').classList.add('fixed-header');
        document.querySelector('body').classList.add('fixed-header');
      } else {
        document.querySelector('.sidebarMobile').classList.remove('fixed-header');
        document.querySelector('body').classList.remove('fixed-header');
      }
    }

  }

}
